var map = {
	"./supplier1.png": 9479,
	"./supplier10.png": 2007,
	"./supplier2.png": 8358,
	"./supplier3.png": 5596,
	"./supplier4.png": 5947,
	"./supplier5.png": 1355,
	"./supplier6.png": 1890,
	"./supplier7.png": 4793,
	"./supplier8.png": 9750,
	"./supplier9.png": 1354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5658;